import React from "react";
import styled from "styled-components";
import { FontSize, message } from "@glossy";
import Button from "@ui-kit/button";
import Text from "@ui-kit/form/text";

export interface IProps extends React.ComponentProps<typeof Text> {
  onValidate?: (any) => void;
  errorMessage?: string;
  hasError: boolean;
  isActive?: boolean;
  setIsActive?: (isActive: boolean) => void;
  className?: string;
}

const Error = styled.div`
  color: ${(props) => message(props, "error")};
  font-size: ${FontSize.Small};
`;

const UiKitFormTextAddMessage = ({
  value,
  placeholder,
  onChange,
  onValidate,
  errorMessage,
  hasError,
  isActive,
  setIsActive,
  className,
}: IProps) => (
  <div className={className}>
    <Text
      {...{ value, placeholder, onChange, hasError }}
      variant="primary"
      isClearable={false}
      onBlur={() => setIsActive && setIsActive(false)}
      onFocus={() => setIsActive && setIsActive(true)}
      customButton={
        isActive &&
        !hasError &&
        onValidate && (
          <div onMouseDown={onValidate}>
            <Button icon="plus" size="xs" variant="primary" />
          </div>
        )
      }
    />
    {hasError && <Error>{errorMessage}</Error>}
  </div>
);

export default UiKitFormTextAddMessage;
